import { S3 } from "aws-sdk";
import { toast } from "react-toastify";

export const lengthFindOfPara = (text) => {
  let indexStart = text?.indexOf("<p>");
  if (indexStart) {
    return text?.slice(indexStart, text?.length - 1);
  }
  return text;
};

export const helperText =
  "In publishing and graphic design, Lorem ipsum is a placeholder text commonly used to demonstrate the visual form of a document or a typeface without relying on meaningful content. Lorem ipsum may be used as a placeholder before final copy is available";

export const htmlRegexG = /<(?:"[^"]*"['"]*|'[^']*'['"]*|[^'">])+>/g;

export const uploadFile = async (e, fullName, type) => {
  const params = {
    Bucket: process.env.REACT_APP_AWS_BUCKET,
    Key: `${type}${fullName}${Date?.now()}.pdf`,
    Body: e.target.files[0],
  };

  const s3 = new S3({
    accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY,
    secretAccessKey: process.env.REACT_APP_AWS_SECRET_KEY,
  });
  try {
    const uploads = s3.upload(params);

    const fileUpload = await uploads.promise();
    let file1 = fileUpload.Location.toString();

    return file1;
  } catch (e) {
    toast.error(e.message);
  }
};
